import { render, staticRenderFns } from "./study-detail.vue?vue&type=template&id=5002636e&scoped=true"
import script from "./study-detail.vue?vue&type=script&lang=js"
export * from "./study-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5002636e",
  null
  
)

export default component.exports